"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./structured-data"));
var CorgiComponentName;
(function (CorgiComponentName) {
    CorgiComponentName["GlobalHead"] = "global-head";
    CorgiComponentName["GTMGlobalScript"] = "gtm-global-script";
    CorgiComponentName["GlobalStyles"] = "global-styles";
    CorgiComponentName["GTMNoScript"] = "gtm-noscript";
    CorgiComponentName["CookieBanner"] = "cookie-banner";
    CorgiComponentName["GlobalSectionHeaderNavigation"] = "global-section-header-navigation";
    CorgiComponentName["SideNav"] = "side-nav";
    CorgiComponentName["HomepageTopTeaser"] = "homepage-top-teaser";
    CorgiComponentName["Breadcrumbs"] = "breadcrumbs";
    CorgiComponentName["FooterLinkSection"] = "footer-link-section";
    CorgiComponentName["TrustIcons"] = "trust-icons";
    CorgiComponentName["CommonDisclaimer"] = "common-disclaimer";
    CorgiComponentName["CommonSmartBanner"] = "common-smart-banner";
    CorgiComponentName["CommonSmartBannerDy"] = "common-smart-banner-dy";
    CorgiComponentName["CommonUspTeaser"] = "common-usp-teaser";
    CorgiComponentName["GTMRegionScript"] = "gtm-region-script";
    CorgiComponentName["ProductVariants"] = "product-variants";
    CorgiComponentName["ArticleHeader"] = "article-header";
    CorgiComponentName["AddToCart"] = "add-to-cart";
    CorgiComponentName["ArticlePrice"] = "article-price";
    CorgiComponentName["ProductMVCOptions"] = "product-mvc-options";
    CorgiComponentName["ProductGallery"] = "product-gallery";
    CorgiComponentName["ProductReviews"] = "product-reviews";
    CorgiComponentName["ArticleDetails"] = "article-details";
    CorgiComponentName["DeliveryTimeNotice"] = "delivery-time-notice";
    CorgiComponentName["OurServices"] = "our-services";
    CorgiComponentName["BannerVoucher"] = "banner-voucher";
    CorgiComponentName["AccessorySlider"] = "accessory-slider";
    CorgiComponentName["ShowroomSlider"] = "showroom-slider";
    CorgiComponentName["CommonVisualNavigation"] = "common-visual-navigation";
    CorgiComponentName["ProductNotFound"] = "product-not-found";
    CorgiComponentName["RecommendationsSlider"] = "recommendations-slider";
    CorgiComponentName["SectionHeader"] = "section-header";
    CorgiComponentName["ReclamationRequestCardList"] = "reclamation-request-card-list";
    CorgiComponentName["ReclamationRequestOrderOverview"] = "reclamation-request-order-overview";
    CorgiComponentName["ReclamationRecapOrderOverview"] = "reclamation-recap-order-overview";
    CorgiComponentName["ReclamationRecapCardList"] = "reclamation-recap-card-list";
    CorgiComponentName["ReclamationDrawer"] = "reclamation-drawer";
    CorgiComponentName["CategoryTree"] = "category-tree";
    CorgiComponentName["CategorySortOptions"] = "category-sort-options";
    CorgiComponentName["CategoryFilters"] = "category-filters";
    CorgiComponentName["CategoryOptionsDrawer"] = "category-options-drawer";
    CorgiComponentName["CategoryOptionsButtons"] = "category-options-buttons";
    CorgiComponentName["CategorySelectedFilters"] = "category-selected-filters";
    CorgiComponentName["ProductListView"] = "product-list-view";
    CorgiComponentName["ProductsListTree"] = "products-list-tree";
    CorgiComponentName["ProductsListOptionsDrawer"] = "products-list-options-drawer";
    CorgiComponentName["InlineQuickView"] = "inline-quickview";
    CorgiComponentName["CommonAlert"] = "common-alert";
    CorgiComponentName["TopBanner"] = "top-banner";
    CorgiComponentName["CartSummary"] = "cart-summary";
    CorgiComponentName["GlobalRibbon"] = "global-ribbon";
    CorgiComponentName["Alert"] = "alert";
    CorgiComponentName["SeoSection"] = "seo-section";
    CorgiComponentName["EmptyList"] = "empty-list";
    CorgiComponentName["CustomerServiceInfo"] = "customer-service-info";
    CorgiComponentName["NewsletterSignup"] = "newsletter-signup";
    CorgiComponentName["CartProductList"] = "cart-product-list";
    CorgiComponentName["CheckoutHeader"] = "checkout-header";
    CorgiComponentName["CheckoutStepHeader"] = "checkout-step-header";
    CorgiComponentName["CheckoutNextSteps"] = "checkout-next-steps";
    CorgiComponentName["AddressForm"] = "address-form";
    CorgiComponentName["NewsletterOverlay"] = "newsletter-overlay";
    CorgiComponentName["CardGrid"] = "card-grid";
    CorgiComponentName["PictureText"] = "picture-text";
    CorgiComponentName["StepProgressBar"] = "step-progress-bar";
    CorgiComponentName["PaymentMethodSelection"] = "payment-method-selection";
    CorgiComponentName["EditAddressDrawer"] = "edit-address-drawer";
    CorgiComponentName["BillingAddress"] = "billing-address";
    CorgiComponentName["ShippingAddress"] = "shipping-address";
    CorgiComponentName["AddressCard"] = "address-card";
    CorgiComponentName["AddressEditableCard"] = "address-editable-card";
    CorgiComponentName["PaymentMethodCard"] = "payment-method-card";
    CorgiComponentName["ContentProductList"] = "content-product-list";
    CorgiComponentName["CommonTabBar"] = "common-tab-bar";
    CorgiComponentName["PrepaymentInfo"] = "prepayment-info";
    CorgiComponentName["NewOrderProductList"] = "new-order-product-list";
    CorgiComponentName["CheckoutSuccessOverviewLinks"] = "checkout-success-overview-links";
    CorgiComponentName["LoginForm"] = "login-form";
    CorgiComponentName["LoginRegisterSection"] = "login-register-section";
    CorgiComponentName["LoginBackToLink"] = "login-back-to-link";
    CorgiComponentName["CtaButtons"] = "cta-buttons";
    CorgiComponentName["ArticlesNavigation"] = "articles-navigation";
    CorgiComponentName["TopNewsSection"] = "top-news-section";
    CorgiComponentName["PasswordForgottenForm"] = "password-forgotten-form";
    CorgiComponentName["PasswordChangeForm"] = "password-change-form";
    CorgiComponentName["PaybackPointsOverview"] = "payback-points-overview";
    CorgiComponentName["ContentSlider"] = "content-slider";
    CorgiComponentName["SovendusBanner"] = "sovendus-banner";
    CorgiComponentName["ClarkBanner"] = "clark-banner";
    CorgiComponentName["RegistrationForm"] = "registration-form";
    CorgiComponentName["ContactBox"] = "contact-box";
    CorgiComponentName["OrderDetailsSummary"] = "order-details-summary";
    CorgiComponentName["OrderCardList"] = "order-card-list";
    CorgiComponentName["OrdersList"] = "orders-list";
    CorgiComponentName["VoucherPromotions"] = "voucher-promotions";
})(CorgiComponentName = exports.CorgiComponentName || (exports.CorgiComponentName = {}));
var StepProgressBarLabel;
(function (StepProgressBarLabel) {
    StepProgressBarLabel["Shipping"] = "shipping";
    StepProgressBarLabel["Payment"] = "payment";
    StepProgressBarLabel["Confirm"] = "confirm";
})(StepProgressBarLabel = exports.StepProgressBarLabel || (exports.StepProgressBarLabel = {}));
var ImageFormat;
(function (ImageFormat) {
    ImageFormat["JPG"] = "JPG";
    ImageFormat["PNG"] = "PNG";
    ImageFormat["GIF"] = "GIF";
    ImageFormat["WEBP"] = "WEBP";
})(ImageFormat = exports.ImageFormat || (exports.ImageFormat = {}));
var ProductsListTreeType;
(function (ProductsListTreeType) {
    ProductsListTreeType[ProductsListTreeType["NavigationMenu"] = 0] = "NavigationMenu";
    ProductsListTreeType[ProductsListTreeType["AliasMenu"] = 1] = "AliasMenu";
    ProductsListTreeType[ProductsListTreeType["RelatedPages"] = 2] = "RelatedPages";
})(ProductsListTreeType = exports.ProductsListTreeType || (exports.ProductsListTreeType = {}));
var ProductEventDataList;
(function (ProductEventDataList) {
    ProductEventDataList["CrossSelling"] = "PDP - Cross-selling";
    ProductEventDataList["UpSelling"] = "PDP - Upselling";
    ProductEventDataList["Accessories"] = "PDP - Accessories";
    ProductEventDataList["Sibling"] = "PDP - Sibling";
    ProductEventDataList["List"] = "PLP - Article list";
    ProductEventDataList["InlineQV"] = "PLP - Inline-Quickview";
    ProductEventDataList["Homepage"] = "HP - Personalization";
    ProductEventDataList["ContentList"] = "Content - Article list";
    ProductEventDataList["ShopTheLook"] = "Content - Shop the look";
})(ProductEventDataList = exports.ProductEventDataList || (exports.ProductEventDataList = {}));
var RecommendationsSliderTypeKey;
(function (RecommendationsSliderTypeKey) {
    RecommendationsSliderTypeKey["UpSelling"] = "upSelling";
    RecommendationsSliderTypeKey["CrossSelling"] = "crossSelling";
    RecommendationsSliderTypeKey["Homepage"] = "homepage";
    RecommendationsSliderTypeKey["ShopTheLook"] = "shopTheLook";
})(RecommendationsSliderTypeKey = exports.RecommendationsSliderTypeKey || (exports.RecommendationsSliderTypeKey = {}));
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["CreditCard"] = "CREDITCARD_PAYONE";
    PaymentMethod["Maestro"] = "MAESTRO_PAYONE";
    PaymentMethod["Installment"] = "INSTALLMENT_AFTERPAY";
    PaymentMethod["Ideal"] = "IDEAL_PAYONE";
    PaymentMethod["Prepayment"] = "PREPAYMENT_H24";
    PaymentMethod["Invoice"] = "INVOICE_H24";
    PaymentMethod["Free"] = "FREE";
    PaymentMethod["PayPal"] = "PAYPAL";
})(PaymentMethod = exports.PaymentMethod || (exports.PaymentMethod = {}));
var UserGender;
(function (UserGender) {
    UserGender["Male"] = "MALE";
    UserGender["Female"] = "FEMALE";
})(UserGender = exports.UserGender || (exports.UserGender = {}));
var ArticleDeliveryType;
(function (ArticleDeliveryType) {
    ArticleDeliveryType["FurnitureShipping"] = "furnitureshipping";
    ArticleDeliveryType["ParcelService"] = "parcelservice";
    ArticleDeliveryType["ShippingCompany"] = "shippingcompany";
    ArticleDeliveryType["Unknown"] = "unknown";
})(ArticleDeliveryType = exports.ArticleDeliveryType || (exports.ArticleDeliveryType = {}));
var OrderType;
(function (OrderType) {
    OrderType["Order"] = "ORDER";
    OrderType["Exchange"] = "EXCHANGE";
    OrderType["Return"] = "RETURN";
    OrderType["SparePart"] = "SPAREPART";
    OrderType["SpareParts"] = "SPAREPARTS";
    OrderType["Undefined"] = "UNDEFINED";
})(OrderType = exports.OrderType || (exports.OrderType = {}));
var OrderDocumentType;
(function (OrderDocumentType) {
    OrderDocumentType["Invoice"] = "INVOICE";
    OrderDocumentType["CreditMemo"] = "CREDIT_MEMO";
    OrderDocumentType["DebitMemo"] = "DEBIT_MEMO";
    OrderDocumentType["ReturnLabel"] = "RETURN_LABEL";
})(OrderDocumentType = exports.OrderDocumentType || (exports.OrderDocumentType = {}));
var OrderItemProcess;
(function (OrderItemProcess) {
    OrderItemProcess["Rejected"] = "REJECTED";
    OrderItemProcess["Remain"] = "REMAIN";
    OrderItemProcess["Lost"] = "LOST";
    OrderItemProcess["NormalReplaced"] = "NORMAL_REPLACED";
    OrderItemProcess["RemainReplaced"] = "REMAIN_REPLACED";
    OrderItemProcess["LostReplaced"] = "LOST_REPLACED";
})(OrderItemProcess = exports.OrderItemProcess || (exports.OrderItemProcess = {}));
var ArticlesSortingScore;
(function (ArticlesSortingScore) {
    ArticlesSortingScore["A"] = "A";
    ArticlesSortingScore["B"] = "B";
    ArticlesSortingScore["B1"] = "B1";
    ArticlesSortingScore["B2"] = "B2";
    ArticlesSortingScore["B3"] = "B3";
    ArticlesSortingScore["B4"] = "B4";
})(ArticlesSortingScore = exports.ArticlesSortingScore || (exports.ArticlesSortingScore = {}));
var PaybackApprovalStatus;
(function (PaybackApprovalStatus) {
    PaybackApprovalStatus["Pending"] = "PENDING";
    PaybackApprovalStatus["Approved"] = "APPROVED";
    PaybackApprovalStatus["Failed"] = "FAILED";
})(PaybackApprovalStatus = exports.PaybackApprovalStatus || (exports.PaybackApprovalStatus = {}));
var PrismicLocale;
(function (PrismicLocale) {
    PrismicLocale["De_DE_h24"] = "de-de";
    PrismicLocale["De_DE_ffh"] = "de-fh";
    PrismicLocale["De_AT"] = "de-at";
    PrismicLocale["De_CH"] = "de-ch";
    PrismicLocale["Fr_BE"] = "fr-be";
    PrismicLocale["Fr_CH"] = "fr-ch";
    PrismicLocale["Fr_FR"] = "fr-fr";
    PrismicLocale["It_IT"] = "it-it";
    PrismicLocale["Nl_BE"] = "nl-be";
    PrismicLocale["Nl_NL"] = "nl-nl";
    PrismicLocale["En_US"] = "en-us";
})(PrismicLocale = exports.PrismicLocale || (exports.PrismicLocale = {}));
var PhraseLocale;
(function (PhraseLocale) {
    PhraseLocale["De_DE_h24"] = "de_DE_h24";
    PhraseLocale["De_DE_ffh"] = "de_DE_ffh";
    PhraseLocale["De_AT"] = "de_AT";
    PhraseLocale["De_CH"] = "de_CH";
    PhraseLocale["Fr_BE"] = "fr_BE";
    PhraseLocale["Fr_CH"] = "fr_CH";
    PhraseLocale["Fr_FR"] = "fr_FR";
    PhraseLocale["It_IT"] = "it_IT";
    PhraseLocale["Nl_BE"] = "nl_BE";
    PhraseLocale["Nl_NL"] = "nl_NL";
})(PhraseLocale = exports.PhraseLocale || (exports.PhraseLocale = {}));
var PrismicSliceType;
(function (PrismicSliceType) {
    PrismicSliceType["Homepage"] = "homepage";
})(PrismicSliceType = exports.PrismicSliceType || (exports.PrismicSliceType = {}));
var PrismicStaticFieldsType;
(function (PrismicStaticFieldsType) {
    PrismicStaticFieldsType["HomepageTopTeaser"] = "top_teaser";
})(PrismicStaticFieldsType = exports.PrismicStaticFieldsType || (exports.PrismicStaticFieldsType = {}));
var Stage;
(function (Stage) {
    Stage["Production"] = "production";
    Stage["Staging"] = "staging";
    Stage["Testing"] = "testing";
    Stage["Development"] = "development";
})(Stage = exports.Stage || (exports.Stage = {}));
var LoggerLevel;
(function (LoggerLevel) {
    LoggerLevel["Trace"] = "trace";
    LoggerLevel["Debug"] = "debug";
    LoggerLevel["Info"] = "info";
    LoggerLevel["Warn"] = "warn";
    LoggerLevel["Error"] = "error";
    LoggerLevel["Fatal"] = "fatal";
    LoggerLevel["Silent"] = "silent";
})(LoggerLevel = exports.LoggerLevel || (exports.LoggerLevel = {}));
var DyPageContextType;
(function (DyPageContextType) {
    DyPageContextType["Homepage"] = "HOMEPAGE";
    DyPageContextType["Category"] = "CATEGORY";
    DyPageContextType["Product"] = "PRODUCT";
    DyPageContextType["Post"] = "POST";
    DyPageContextType["Cart"] = "CART";
    DyPageContextType["Other"] = "OTHER";
})(DyPageContextType = exports.DyPageContextType || (exports.DyPageContextType = {}));
var ShopType;
(function (ShopType) {
    ShopType["H24"] = "H24";
})(ShopType = exports.ShopType || (exports.ShopType = {}));
var PageName;
(function (PageName) {
    PageName["HP"] = "HP";
    PageName["PDP"] = "PDP";
    PageName["PLP"] = "PLP";
    PageName["Cart"] = "Cart";
    PageName["Common"] = "x";
})(PageName = exports.PageName || (exports.PageName = {}));
var ProductListMode;
(function (ProductListMode) {
    ProductListMode["Category"] = "Category";
    ProductListMode["ContentTree"] = "ContentTree";
})(ProductListMode = exports.ProductListMode || (exports.ProductListMode = {}));
var CartSummaryType;
(function (CartSummaryType) {
    CartSummaryType["Cart"] = "Cart";
    CartSummaryType["CheckoutShipping"] = "CheckoutShipping";
    CartSummaryType["CheckoutPayment"] = "CheckoutPayment";
    CartSummaryType["CheckoutConfirm"] = "CheckoutConfirm";
    CartSummaryType["CheckoutSuccess"] = "CheckoutSuccess";
    CartSummaryType["OrderDetails"] = "OrderDetails";
})(CartSummaryType = exports.CartSummaryType || (exports.CartSummaryType = {}));
var SectionHeaderType;
(function (SectionHeaderType) {
    SectionHeaderType["Default"] = "DEFAULT";
    SectionHeaderType["Cart"] = "CART";
    SectionHeaderType["OrdersOverview"] = "ORDERS_OVERVIEW";
})(SectionHeaderType = exports.SectionHeaderType || (exports.SectionHeaderType = {}));
var CheckoutPageType;
(function (CheckoutPageType) {
    CheckoutPageType["Shipping"] = "SHIPPING";
    CheckoutPageType["Payment"] = "PAYMENT";
    CheckoutPageType["Confirm"] = "CONFIRM";
    CheckoutPageType["Success"] = "SUCCESS";
})(CheckoutPageType = exports.CheckoutPageType || (exports.CheckoutPageType = {}));
var EmptyListType;
(function (EmptyListType) {
    EmptyListType["Cart"] = "CART";
    EmptyListType["OrdersOverview"] = "ORDERS_OVERVIEW";
})(EmptyListType = exports.EmptyListType || (exports.EmptyListType = {}));
var AppDomainProduction;
(function (AppDomainProduction) {
    AppDomainProduction["de_DE"] = "https://www.home24.de/";
    AppDomainProduction["de_AT"] = "https://www.home24.at/";
    AppDomainProduction["de_CH"] = "https://www.home24.ch/";
    AppDomainProduction["fr_BE"] = "https://www.home24.be/fr/";
    AppDomainProduction["fr_CH"] = "https://www.home24.ch/fr/";
    AppDomainProduction["fr_FR"] = "https://www.home24.fr/";
    AppDomainProduction["it_IT"] = "https://www.home24.it/";
    AppDomainProduction["nl_BE"] = "https://www.home24.be/";
    AppDomainProduction["nl_NL"] = "https://www.home24.nl/";
})(AppDomainProduction = exports.AppDomainProduction || (exports.AppDomainProduction = {}));
var AppDomainStaging;
(function (AppDomainStaging) {
    AppDomainStaging["de_DE"] = "https://www-sapstaging.home24.de/";
    AppDomainStaging["de_AT"] = "https://www-sapstaging.home24.at/";
    AppDomainStaging["de_CH"] = "https://www-sapstaging.home24.ch/";
    AppDomainStaging["fr_BE"] = "https://www-sapstaging.home24.be/fr/";
    AppDomainStaging["fr_CH"] = "https://www-sapstaging.home24.ch/fr/";
    AppDomainStaging["fr_FR"] = "https://www-sapstaging.home24.fr/";
    AppDomainStaging["it_IT"] = "https://www-sapstaging.home24.it/";
    AppDomainStaging["nl_BE"] = "https://www-sapstaging.home24.be/";
    AppDomainStaging["nl_NL"] = "https://www-sapstaging.home24.nl/";
})(AppDomainStaging = exports.AppDomainStaging || (exports.AppDomainStaging = {}));
var AppDomainProductionBilingual;
(function (AppDomainProductionBilingual) {
    AppDomainProductionBilingual["de_DE"] = "https://www.home24.de/";
    AppDomainProductionBilingual["de_AT"] = "https://www.home24.at/";
    AppDomainProductionBilingual["de_CH"] = "https://www.home24.ch/de/";
    AppDomainProductionBilingual["fr_BE"] = "https://www.home24.be/fr/";
    AppDomainProductionBilingual["fr_CH"] = "https://www.home24.ch/fr/";
    AppDomainProductionBilingual["fr_FR"] = "https://www.home24.fr/";
    AppDomainProductionBilingual["it_IT"] = "https://www.home24.it/";
    AppDomainProductionBilingual["nl_BE"] = "https://www.home24.be/nl/";
    AppDomainProductionBilingual["nl_NL"] = "https://www.home24.nl/";
})(AppDomainProductionBilingual = exports.AppDomainProductionBilingual || (exports.AppDomainProductionBilingual = {}));
var AppDomainStagingBilingual;
(function (AppDomainStagingBilingual) {
    AppDomainStagingBilingual["de_DE"] = "https://www-sapstaging.home24.de/";
    AppDomainStagingBilingual["de_AT"] = "https://www-sapstaging.home24.at/";
    AppDomainStagingBilingual["de_CH"] = "https://www-sapstaging.home24.ch/de/";
    AppDomainStagingBilingual["fr_BE"] = "https://www-sapstaging.home24.be/fr/";
    AppDomainStagingBilingual["fr_CH"] = "https://www-sapstaging.home24.ch/fr/";
    AppDomainStagingBilingual["fr_FR"] = "https://www-sapstaging.home24.fr/";
    AppDomainStagingBilingual["it_IT"] = "https://www-sapstaging.home24.it/";
    AppDomainStagingBilingual["nl_BE"] = "https://www-sapstaging.home24.be/nl/";
    AppDomainStagingBilingual["nl_NL"] = "https://www-sapstaging.home24.nl/";
})(AppDomainStagingBilingual = exports.AppDomainStagingBilingual || (exports.AppDomainStagingBilingual = {}));
var PrismicDocumentType;
(function (PrismicDocumentType) {
    PrismicDocumentType["GlobalNavigation"] = "global_navigation";
    PrismicDocumentType["GlobalNavigationItem"] = "global_navigation_item";
})(PrismicDocumentType = exports.PrismicDocumentType || (exports.PrismicDocumentType = {}));
var PrismicDocumentUid;
(function (PrismicDocumentUid) {
    PrismicDocumentUid["GlobalNavigation"] = "global-navigation";
    PrismicDocumentUid["GlobalNavigationContentTree"] = "global-navigation-content-tree";
})(PrismicDocumentUid = exports.PrismicDocumentUid || (exports.PrismicDocumentUid = {}));
var AddressType;
(function (AddressType) {
    AddressType["Shipping"] = "shipping";
    AddressType["Billing"] = "billing";
})(AddressType = exports.AddressType || (exports.AddressType = {}));
var SignupBackToLinkType;
(function (SignupBackToLinkType) {
    SignupBackToLinkType["Login"] = "LOGIN";
    SignupBackToLinkType["Shop"] = "SHOP";
    SignupBackToLinkType["Checkout"] = "CHECKOUT";
})(SignupBackToLinkType = exports.SignupBackToLinkType || (exports.SignupBackToLinkType = {}));
var SignupFlow;
(function (SignupFlow) {
    SignupFlow["MyAccount"] = "myAccount";
    SignupFlow["Checkout"] = "checkout";
    SignupFlow["Redirect"] = "redirect";
})(SignupFlow = exports.SignupFlow || (exports.SignupFlow = {}));
